import axiosIns from '@/api/axios';

export const GET_TRAINING = (args) => {
    return axiosIns.get(`/training?${args}`);
}

export const GET_TRAINING_BY_COMPETENCY = (providerId, competency) => {
    return axiosIns.get(`/master-data/training?provider=${providerId}&competency=${competency}`);
}

export const CREATE_TRAINING = (args) => {
    return axiosIns.post('/training', args)
}
export const EDIT_TRAINING = (args) => {
    return axiosIns.put(`/training/${args.id}`, args.requestData)
}
export const GET_TRAINING_DETAIL = (args) => {
    return axiosIns.get(`/training/${args}`, args)
}

export const GET_TRAINING_DETAIL_PROPOSSED = (args) => {
    return axiosIns.get(`/training/${args}/propossed-time`, args)
}


